document.addEventListener("DOMContentLoaded", function(event) { 
    let faqs = document.querySelectorAll('.structured-faq-item');

    if (faqs.length > 1) {
        var scriptContents = '{"@context": "https://schema.org", "@type": "FAQPage", "mainEntity": [';

        faqs.forEach(function(faqItem, index) {
            let question = faqItem.querySelector(".structured-faq-question").innerText.trim().replace(/"/gi, '&quot;');
            let answer = faqItem.querySelector(".structured-faq-answer").innerText.trim().replace(/"/gi, '&quot;');

            if (question.length > 0 && answer.length > 0) {
                if (index > 0) {
                    scriptContents += ",";
                }

                scriptContents += '{"@type": "Question","name": "' + question + '", "acceptedAnswer": {"@type": "Answer", "text": "' + answer + '"}}';
            }
        });

        scriptContents += ']}';
        const script = document.createElement('script');
        script.setAttribute('type', 'application/ld+json');
        script.textContent = scriptContents;
        document.head.appendChild(script);
    }
});